import React from 'react';
import styled from 'styled-components';
import { palette } from './design-system/colors';
import { FlexDiv } from './design-system/containers';
import { TextTiny } from './design-system/texts';
import UnfoldMore from '@mui/icons-material/UnfoldMore';
import pluralize from 'pluralize';
import { useTranslation } from 'react-i18next';

const Divider = styled.div`
    display: flex;
    align-items: center;
    text-align: center;

    &::before,
    &::after {
        content: '';
        flex: 1;
        border-bottom: 1px solid ${palette.lightroom.heavyMetalLightHigh};
    }

    &:not(:empty)::before {
        margin-right: 0.25em;
    }
    &:not(:empty)::after {
        margin-left: 0.25em;
    }
`;

function DividerWithContent({ items, onClick }) {
    const { t } = useTranslation('assessment');

    return (
        <Divider onClick={() => onClick(items.map((a) => a.value))}>
            <FlexDiv borderRadius={50} border py={4} px={8} link>
                <TextTiny>
                    <UnfoldMore fontSize="small" />
                    {items.length} {t(pluralize('message', items.length))}{' '}
                </TextTiny>
            </FlexDiv>
        </Divider>
    );
}

export default DividerWithContent;
